// Typed wrapper around /api/v1/admin/billing — the cluster's monthly fee + per-unit
// overrides (Billing → Fees page).

import type {
  MonthlyFeeConfig,
  SetMonthlyFeeRequest,
  SetUnitFeeOverrideRequest,
} from '@livinhome/shared';
import { api } from './api-client';

export type { MonthlyFeeConfig };

export async function getFeeConfig(): Promise<MonthlyFeeConfig> {
  const { data } = await api.get<MonthlyFeeConfig>('/admin/billing/fee');
  return data;
}

export async function setMonthlyFee(body: SetMonthlyFeeRequest): Promise<MonthlyFeeConfig> {
  const { data } = await api.put<MonthlyFeeConfig>('/admin/billing/fee', body);
  return data;
}

export async function setUnitOverride(body: SetUnitFeeOverrideRequest): Promise<MonthlyFeeConfig> {
  const { data } = await api.put<MonthlyFeeConfig>('/admin/billing/fee/override', body);
  return data;
}
